import { type Ref, onMounted, onBeforeUnmount, unref } from 'vue'

export const useDetectOutsideClick = (
  element: Ref<HTMLElement | null | undefined> | HTMLElement,
  cb: () => Promise<void> | void,
) => {
  const listener = (event: Event) => {
    const elm = unref(element)

    if (!elm || (event.target !== elm && event.composedPath().includes(elm))) {
      return
    }

    cb()
  }

  onMounted(() => {
    window.addEventListener('click', listener)
  })

  onBeforeUnmount(() => {
    window.removeEventListener('click', listener)
  })

  return { listener }
}
